const CACHE_BLOG_POST = 'CACHE_BLOG_POST'
const CACHE_BLOG_POSTS = 'CACHE_BLOG_POSTS'

export default {
  CACHE_BLOG_POST,
  CACHE_BLOG_POSTS
}
